import React from "react";

const ShippingPolicy = () => {
    return (
        <div className="policy-container">
            <h1>Shipping & Delivery Policy</h1>

            <p>
                At <strong>Radical Sports India</strong>, we aim to provide timely and secure delivery of all sports gear, uniforms, and related products across India. Please review our shipping policy to understand how your order will be handled.
            </p>

            <h2>1. Order Processing</h2>
            <p>
                All orders are processed within <strong>1–2 business days</strong> after successful payment confirmation. Orders placed on weekends or public holidays will be processed the following working day.
            </p>

            <h2>2. Delivery Areas</h2>
            <p>
                We currently ship to most cities and towns across India. In the rare case that your location is not serviceable, our team will notify you and issue a full refund if necessary.
            </p>

            <h2>3. Estimated Delivery Time</h2>
            <ul>
                <li><strong>Metro Cities:</strong> 2–5 business days</li>
                <li><strong>Tier 2/3 Cities:</strong> 4–7 business days</li>
                <li><strong>Remote Areas:</strong> 7–10 business days</li>
            </ul>
            <p>
                Please note: Delivery times may vary due to courier availability, weather conditions, or other logistical challenges.
            </p>

            <h2>4. Shipping Charges</h2>
            <p>
                Shipping charges depend on the weight, dimensions, and delivery location. Final shipping costs will be shown during checkout before payment.
            </p>

            <h2>5. Tracking Your Order</h2>
            <p>
                Once your order is dispatched, a tracking ID will be shared with you via email or SMS. You can use this ID to track your shipment through the courier's tracking portal.
            </p>

            <h2>6. Delays & Exceptions</h2>
            <p>
                While we strive for timely delivery, delays may occasionally occur due to unforeseen circumstances. We will keep you informed in such cases and work closely with logistics partners to ensure resolution.
            </p>

            <h2>7. Damaged or Lost Packages</h2>
            <p>
                If your parcel arrives visibly damaged or tampered with, please reject it and notify us immediately. In case of lost shipments, we will coordinate with the courier and either replace the item or offer a refund after investigation.
            </p>

            <h2>8. Change of Address</h2>
            <p>
                Address changes can be requested before dispatch. Once shipped, address changes may not be possible. Kindly double-check your delivery details at checkout.
            </p>

            <h2>9. Support</h2>
            <p>
                For any queries or concerns related to shipping or delivery, please contact us:
            </p>
            <ul>
                <li><strong>Email:</strong> Info@radicalsportsindia.com</li>
                <li><strong>Phone:</strong> +91 76546 4545</li>
            </ul>
        </div>
    );
};

export default ShippingPolicy;
